import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { RootSkeleton } from '~/skeleton';
import { AbsRemixPage, StaticHead } from '@lemon8/web-app-shared/ssr';
import { $SEOCurrentTraffic } from 'shared/atoms/common/traffic';

export abstract class RemixPage extends AbsRemixPage {
  Head: FC = () => null;

  HeadSkeleton: FC = () => {
    return (
      <StaticHead>
        <title>Lemon8 Loading...</title>
      </StaticHead>
    );
  };
  BodySkeleton: FC = () => {
    return <RootSkeleton />;
  };

  useRouteLoading = (): boolean => {
    const { href } = useAtomValue($SEOCurrentTraffic);

    if (__BUILD_TARGET__ === 'server') {
      return false;
    }

    if (!href) {
      return true;
    }

    const a = new URL(href);
    return location.pathname !== a.pathname;
  };
}
